import type {
  LegacyRoadDocument,
  LevelId,
  MissionKind,
  WorldMapDocument,
  WorldMapNodeDocument,
} from "../../content/types";
import {
  G_roadStraight,
  G_roadTurnBig,
  G_roadTurnLong,
  G_roadTurnLongB,
  G_roadTurnSmall,
  G_roadTurnSmallB,
} from "../assets";
import type { BitmapSource } from "./menus";

export interface WorldMapDisplayNode {
  readonly id: LevelId;
  readonly x: number;
  readonly y: number;
  readonly label: string;
  readonly area: string;
  readonly mission?: MissionKind;
  readonly iconSide?: "top" | "right" | "bottom" | "left";
}

export const LEGACY_ROAD_ASSETS: Readonly<
  Record<LegacyRoadDocument["asset"], BitmapSource>
> = {
  straight: G_roadStraight,
  "turn-big-a": G_roadTurnBig,
  "turn-big-b": G_roadTurnLongB,
  "turn-long": G_roadTurnLong,
  "turn-small-a": G_roadTurnSmall,
  "turn-small-b": G_roadTurnSmallB,
};

export const ICON_OFFSETS: Readonly<
  Record<
    NonNullable<WorldMapNodeDocument["iconSide"]>,
    readonly [number, number]
  >
> = {
  top: [0, -22],
  right: [22, 0],
  bottom: [0, 22],
  left: [-22, 0],
};

/** Returns unlocked authored nodes in stable document order. */
export function selectableMapNodes(
  worldMap: WorldMapDocument,
  unlockedLevels: readonly LevelId[],
): readonly WorldMapDisplayNode[] {
  const unlocked = new Set(unlockedLevels);
  return worldMap.nodes.filter((node) => unlocked.has(node.id));
}
